module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","heading":"News","detail":"Detail","no-data":"No data","table":{"date":"Date","content":"Descriptions"}},"zh_hk":{"home":"首頁","heading":"最新消息","detail":"詳情","no-data":"沒有消息","table":{"date":"日期","content":"描述"}},"zh_cn":{"home":"首页","heading":"最新消息","detail":"详情","no-data":"没有消息","table":{"date":"日期","content":"描述"}}}')
  delete Component.options._Ctor
}
